module.exports = window.crypto;


//////////////////
// WEBPACK FOOTER
// ./~/randomhex/src/browser.js
// module id = 592
// module chunks = 0